export const ProjectNotFound = () => {
  return (<div className="m-4 flex flex-col items-center"><div className="text-3xl">Project not found </div></div>);
}